module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 512 209.4",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }